import React, { PureComponent } from 'react';
import { GetHistory } from 'app/components/router/History';
import { History, NavigationBlockerType } from 'app/services/history';

interface IBaseProps {
  children?: null | undefined;
}

interface IMessagePrompt extends IBaseProps {
  message: string;
}

interface IBlockerPrompt extends IBaseProps {
  history: History;
  blocker: NavigationBlockerType;
}

export class BaseBlockNavigation extends PureComponent<IBlockerPrompt> {
  private removeBlocker?: () => void;

  public componentDidMount = () => {
    this.removeBlocker = this.props.history.addNavigationBlocker(this.props.blocker);
  };

  public componentDidUpdate = () => {
    this.componentWillUnmount();
    this.componentDidMount();
  };

  public componentWillUnmount = () => {
    if (this.removeBlocker) {
      this.removeBlocker();
    }
  };

  public render = () => {
    return null;
  };
}

export const BlockNavigation: React.FunctionComponent<Omit<IBlockerPrompt, 'history'>> = ({
  blocker,
}) => (
  <GetHistory>{history =>
    <BaseBlockNavigation history={history} blocker={blocker} />
  }</GetHistory>
);

const Prompt: React.FunctionComponent<IMessagePrompt> = ({
  message,
}) => (
  /* Always return a message, the decision to block is implicit in that
   * the component is being rendered at all */
  <BlockNavigation blocker={() => message} />
);

export default Prompt;
